import { render } from "./ReceiptIcon.vue?vue&type=template&id=7b72eeb3"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ReceiptIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b72eeb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b72eeb3', __exports__)) {
    api.reload('7b72eeb3', __exports__)
  }
  
  module.hot.accept("./ReceiptIcon.vue?vue&type=template&id=7b72eeb3", () => {
    api.rerender('7b72eeb3', render)
  })

}


export default __exports__